import { CreateEezycoinOfferingPayload, EezycoinOffering } from "src/apis/eezycoin";

export const eezycoinApiToFormValues = (offering: EezycoinOffering): CreateEezycoinOfferingPayload => {
  return {
    coins_included: offering?.coins_included,
    company_id: offering?.fk_company_id,
    description: offering?.description,
    is_active: offering?.is_active,
    is_eezyfamily_offer: offering?.is_eezyfamily_offer,
    title: offering?.title,
    total_value: (offering?.total_value_cents / 100)
  }
}
